/// SPDX-License-Identifier: GPL-3.0-or-later
/// SPDX-FileCopyrightText: Copyright © 2024-2026 Tony Garnock-Jones <tonyg@leastfixedpoint.com>

export function exhaustive(v: never): never {
    throw new Error("Internal error: Exhaustiveness check failed: " + v);
}
